import React, { useState, useEffect } from "react";
import arePropsEqual from "../../utils/arePropsEqual";
import Tooltip from "../shared/Tooltip";

const Spinner = (props) => (
  <span className={`cf-loading-spinner reports-spinner ${props.left == true ? 'left' : ''}`}></span>
);

const ReportCount = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [count, setCount] = useState(
    !props.count || props.count == 0 ? 0 : props.count
  );
  const [comparisonCount, setComparisonCount] = useState(null);
  const [percentageChange, setPercentageChange] = useState(null);
  const [liftIsHovered, setLiftIsHovered] = useState(false);
  const inlineBadgeBelow = props.comparison_badge_below === true;
  const hideComparisonBadge = props.hide_comparison_badge === true;
  const hideComparisonLabel = props.hide_comparison_label === true;

  // React 18 batches every setState call after an await into one commit.
  const [callbackTick, setCallbackTick] = useState(0);

  const getReport = async (payload) => {
    console.log("fetch count", payload);
    try {
      setIsLoading(true);
      setHasError(false);
      const response = await fetch(`${props.path}?` + $.param(payload));
      const json = await response.json();
      setCount(json);
      setIsLoading(false);
      setCallbackTick((tick) => tick + 1);
    } catch (error) {
      console.log("error", error);
      setHasError(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (callbackTick > 0 && props.callback) {
      props.callback();
    }
  }, [callbackTick]);

  const getComparisonReport = async (payload) => {
    console.log("fetch comparison count", payload);
    try {
      const response = await fetch(`${props.path}?` + $.param(payload));
      const json = await response.json();
      setComparisonCount(json);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  }, []);

  useEffect(() => {
    if (!props.count && props.count !== 0) {
      getReport(props.payload);
    }
  }, [props.payload]);

  useEffect(() => {
    if (props.comparison_payload) {
      getComparisonReport(props.comparison_payload);
    } else {
      // Reset comparison count when comparison_payload becomes null
      setComparisonCount(null);
    }
  }, [props.comparison_payload]);

  useEffect(() => {
    if (!props.comparison_payload) {
      // Reset percentage change when comparison_payload becomes null
      setPercentageChange(null);
    } else if (comparisonCount !== null && count !== null && comparisonCount !== 0) {
      const change = ((count - comparisonCount) / comparisonCount) * 100;
      setPercentageChange(Math.round(change));
    } else if (comparisonCount === 0 && count > 0) {
      setPercentageChange(100);
    } else if (comparisonCount !== null) {
      setPercentageChange(0);
    }
  }, [count, comparisonCount, props.comparison_payload]);

  if (props.selector_to_assign_data_attr) {
    useEffect(() => {
      $(props.selector_to_assign_data_attr).attr('data-count', count);
    }, [count]);
  }

  useEffect(() => {
    // Set comparison count data attribute for use by updateConversionRate
    // This allows conversion rate comparisons to be calculated
    if (props.id && props.comparison_payload && comparisonCount !== null && comparisonCount !== undefined) {
      $(`#${props.id}`).attr('data-comparison-count', comparisonCount);
    } else if (props.id && !props.comparison_payload) {
      // Remove the attribute when comparison_payload is null
      $(`#${props.id}`).removeAttr('data-comparison-count');
    } else if (props.id && props.comparison_payload && comparisonCount === null) {
      // If comparison payload exists but count is null, remove the attribute
      // to indicate comparison data is not yet available
      $(`#${props.id}`).removeAttr('data-comparison-count');
    }
  }, [comparisonCount, props.id, props.comparison_payload]);

  const displayedCount = props.count ?? count;

  return (
    <React.Fragment>
      {!props.inline && !props.unstyled && (
        <div className="row hard-center">
          <div className="row hard-center">
            <span className="field-title text-left">{props.label}</span>
            {props.tooltip && (
              <Tooltip
                tooltip={props.tooltip}
                inline={true}
                hover={props.tooltipHover}
              />
            )}
          </div>
          <div className="row hard-center gap-2">
            <h4
              className="report-count bold"
              style={{ margin: "5px 0px 0px" }}
            >
              {props.currency ? props.currency : ""}
              <span id={props.id} data-loading={isLoading} data-count={hasError ? "" : displayedCount}>
                {props.loader && (isLoading || hasError) ? (
                  <Spinner left={props.left} />
                ) : (
                  displayedCount.toLocaleString()
                )}
              </span>
            </h4>
            {!hideComparisonBadge && (percentageChange !== null || (props.comparison_payload && comparisonCount === null)) && (
              <span
                className={`inline-flex items-center px-2 py-1 rounded text-base font-medium ${
                  percentageChange !== null
                    ? percentageChange > 0
                      ? "bg-green-100 text-green-800"
                      : percentageChange < 0
                      ? "bg-red-100 text-red-800"
                      : "bg-gray-100 text-gray-800"
                    : "bg-gray-100 text-gray-800"
                }`}
                onMouseEnter={() => {
                  setLiftIsHovered(true);
                }}
                onMouseLeave={() => {
                  setLiftIsHovered(false);
                }}
              >
                {percentageChange !== null ? (
                  <>
                    {percentageChange > 0 ? (
                      <svg
                        className="w-4 h-4 mr-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        style={{ transform: 'rotate(-45deg)' }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ) : percentageChange < 0 ? (
                      <svg
                        className="w-4 h-4 mr-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        style={{ transform: 'rotate(45deg)' }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ) : null}
                    {Math.abs(percentageChange)}%
                    {!hideComparisonLabel && (
                      <span style={{ display: liftIsHovered ? 'inline-block' : 'none' }}>
                        {props.comparison_label || "vs last period"}
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    <span className="cf-loading-spinner reports-spinner" style={{ width: '12px', height: '12px', marginRight: '4px' }}></span>
                  </>
                )}
              </span>
            )}
          </div>
        </div>
      )}

      {props.inline && (
        <span className={props.unstyled ? "" : "bold"}>
          {props.currency ? props.currency : ""}
          <span
            id={props.id}
            className={props.unstyled ? "" : "events-report-count"}
            data-loading={isLoading}
            data-count={hasError ? "" : displayedCount}
          >
            {props.loader && (isLoading || hasError) ? (
              <Spinner left={props.left} />
            ) : (
              displayedCount.toLocaleString()
            )}
          </span>
          {!hideComparisonBadge && (percentageChange !== null || (props.comparison_payload && comparisonCount === null)) && (
            <span
              style={
                inlineBadgeBelow
                  ? { display: "block", marginTop: "4px", width: "fit-content" }
                  : undefined
              }
            >
              <span
                className={`inline-flex items-center px-2 py-1 ${inlineBadgeBelow ? "" : "ml-2"} rounded text-base font-medium ${
                  percentageChange !== null
                    ? percentageChange > 0
                      ? "bg-green-100 text-green-800"
                      : percentageChange < 0
                      ? "bg-red-100 text-red-800"
                      : "bg-gray-100 text-gray-800"
                    : "bg-gray-100 text-gray-800"
                }`}
                title={hideComparisonLabel ? undefined : (props.comparison_label || "vs last period")}
                onMouseEnter={() => {
                  setLiftIsHovered(true);
                }}
                onMouseLeave={() => {
                  setLiftIsHovered(false);
                }}
              >
                {percentageChange !== null ? (
                  <>
                    {percentageChange > 0 ? (
                      <svg
                        className="w-4 h-4 mr-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        style={{ transform: "rotate(-45deg)" }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ) : percentageChange < 0 ? (
                      <svg
                        className="w-4 h-4 mr-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        style={{ transform: "rotate(45deg)" }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ) : null}
                    {Math.abs(percentageChange)}%
                    {!hideComparisonLabel && (
                      <span
                        style={{
                          display: liftIsHovered ? "inline-block" : "none",
                          marginLeft: "4px",
                        }}
                      >
                        {props.comparison_label || "vs last period"}
                      </span>
                    )}
                  </>
                ) : (
                  <span
                    className="cf-loading-spinner reports-spinner"
                    style={{ width: "12px", height: "12px", marginRight: "4px" }}
                  ></span>
                )}
              </span>
            </span>
          )}
        </span>
      )}
    </React.Fragment>
  );
};

export default React.memo(ReportCount, arePropsEqual);
